// SiteUp (G6 / IF4-C): a decisão sobre o grupo (adiar ou "não é a mesma
// pessoa") vem do servidor em `group.review` e vale para toda a equipe.
// Antes ficava no localStorage de quem clicou.

export const SNOOZE_DAYS = 7;

export const resolveReviewTab = (review, now = Date.now()) => {
  if (!review?.status) return 'pending';
  if (review.status === 'ignored') return 'ignored';
  if (review.status === 'snoozed') {
    const until = new Date(review.snoozed_until).getTime();
    return until > now ? 'snoozed' : 'pending';
  }
  return 'pending';
};
